<template>
    <div class="total-duration">
        <div v-if="hours" class="total-duration__row">
            <div class="total-duration__time">{{ hours }}</div>
            <div class="total-duration__heading">{{ hoursLabel }}</div>
        </div>
        <div class="total-duration__row">
            <div class="total-duration__time">{{ minutes }}</div>
            <span class="total-duration__heading">{{ minutesLabel }}</span>
        </div>
    </div>
</template>

<script setup lang="ts">
import { secondsToClosestMinutes } from '@/features/common/helpers';
import { secondsToHours } from 'date-fns';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

interface Props {
    modelValue: number;
}

const props = defineProps<Props>();
const { t } = useI18n();
const hours = computed(() => secondsToHours(props.modelValue));
const minutes = computed(() => secondsToClosestMinutes(props.modelValue - hours.value * 3600));
const hoursLabel = computed(() => t('common.resources.hoursLong', hours.value, { default: 'hours | hour | hours' }));
const minutesLabel = computed(() => t('common.resources.minutesShort', minutes.value, { default: 'mins | min | mins' }));
</script>

<style lang="scss">
@use 'vuetify/settings' as *;
@use 'vuetify/lib/styles/tools/index' as tools;

.total-duration {
    width: 25px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    gap: 3px;

    &__row {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
    }

    &__time {
        color: var(--v-color-grey-darken-5);
        @include tools.typography(20px, 700, 0 !important, 16px, none !important);
    }

    &__heading {
        white-space: nowrap;
        color: var(--v-color-grey-darken-3);
        @include tools.typography(14px, 400, 0 !important, 12px, none !important);
    }
}
</style>
